var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"header":_vm.$t('CARD_PASSWORD_RESET_TITLE')}},[_c('b-card-text',[_c('LangTemplate',{attrs:{"path":"CARD_PASSWORD_RESET_DESCRIPTION"},scopedSlots:_vm._u([{key:"find_your_id_link",fn:function(){return [_c('a',{attrs:{"href":_vm.$t('FIND_YOUR_ID_LINK')}},[_vm._v(_vm._s(_vm.$t('FIND_YOUR_ID_LINK_NAME')))])]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }